import React from "react";

import FooterView from "../../rows/footer";

export const Footer = () => <FooterView />;
